export const deviceTableColumns = [
  {
    key: "check",
    display_name: "",
    cellStyles: {
      "font-size": "13px",
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      borderRadius: "6px 0 0",
      width: "5%",
      color: "#fff",
    },
    _config: {
      type: "checkbox",
      displayInColumn: false,
    },
  },
  {
    key: "name",
    display_name: "Device Name",
    cellStyles: {
      "font-size": "13px",
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      color: "#fff",
    },
    _config: {
      type: "link",
      displayInColumn: false,
    },
  },
  {
    key: "deviceType",
    display_name: "Device Type",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",

      "font-weight": "600",
      color: "#fff",
    },
    _config: {
      isFormatedText: true,
    }
  },
  {
    key: "platform",
    display_name: "Platform",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      color: "#fff",

      "font-weight": "600",
    },
    _config: {
      isFormatedText: true,
    }
  },
  {
    key: "environment",
    display_name: "Environment",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",

      "font-weight": "600",
      color: "#fff",
    },
    _config: {
      isFormatedText: true,
    }
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      "font-weight": "600",
      width: "6%",
      color: "#fff",
    },
    _config: {
      displayInColumn: false,
      type: "svg",
      value: "../../../../assets/images/table/table-item-edit.svg",
      isClickable: "true",
    },
  },
];
